/* LJV — Ähnliche Produkte.
 *
 * Fuellt die Section mit Produkten DESSELBEN Produkttyps, in dieser Reihenfolge:
 *   1. Shopify-Empfehlungen mit passendem Typ  (datenbasiert die relevantesten)
 *   2. weitere Produkte desselben Typs         (Storefront-Suche product_type:)
 *   3. restliche Shopify-Empfehlungen          (nur als Notnagel bei seltenen Typen)
 *
 * Warum nachgeladen statt serverseitig: Liquid kann nicht frei nach Produkttyp suchen.
 * Dasselbe Muster nutzt Prestige bereits fuer "Zuletzt angesehen".
 *
 * Zuordnung ueber das handle-Attribut, das product-card ohnehin traegt.
 *
 * Ausgabe ist Prestiges eigener Slider (Desktop: eine Reihe, Pfeile bei Hover) —
 * die Huelle liefert die Section als <template>, hier werden nur die Karten eingesetzt.
 * Mobil formt ljv-recs-grid.css denselben Slider zum zweireihigen Wischraster um.
 */
(function () {
  'use strict';

  var GHOST_TYPE = 'giftbox_ghost_product';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cardsFrom(html) {
    if (!html) return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.prototype.slice.call(doc.querySelectorAll('product-card'));
  }

  function get(url) {
    return fetch(url, { priority: 'low' })
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .catch(function () {
        return '';
      });
  }

  function getJson(url) {
    return fetch(url, { priority: 'low' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  var LjvSimilarProducts = class extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;
      this.load();
    }

    async load() {
      var section = this.closest('.shopify-section');
      var sectionId = section ? section.id.replace('shopify-section-', '') : '';
      var productId = this.getAttribute('product-id');
      var productType = this.getAttribute('product-type') || '';
      var want = parseInt(this.getAttribute('products-count') || '10', 10);

      if (!sectionId || !productId) return this.giveUp(section);

      var recUrl =
        root() + 'recommendations/products?section_id=' + sectionId + '&product_id=' + productId + '&limit=10&intent=related';
      var typeUrl = productType
        ? root() +
          'search?type=product&section_id=' +
          sectionId +
          '&q=' +
          encodeURIComponent('product_type:"' + productType + '"')
        : '';

      var results = await Promise.all([
        getJson(root() + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related'),
        get(recUrl),
        typeUrl ? get(typeUrl) : Promise.resolve('')
      ]);

      var recJson = results[0];
      var recCards = cardsFrom(results[1]);
      var typeCards = cardsFrom(results[2]);

      // Produkttyp je Handle — die Karten selbst tragen ihn nicht.
      var typeOf = {};
      if (recJson && Array.isArray(recJson.products)) {
        recJson.products.forEach(function (p) {
          typeOf[p.handle] = p.type;
        });
      }

      var picked = [];
      var seen = {};
      var self = this;

      function add(card) {
        var handle = card.getAttribute('handle');
        if (!handle || seen[handle]) return;
        seen[handle] = true;
        picked.push(card);
      }

      // 1) Empfehlungen mit passendem Typ, in der Reihenfolge von Shopify.
      //    Bewusst aus dem Empfehlungs-HTML und nicht aus den Typ-Treffern:
      //    die Typ-Suche liefert nur einen Ausschnitt, die passenden
      //    Empfehlungen liegen oft ausserhalb davon.
      recCards.forEach(function (card) {
        if (typeOf[card.getAttribute('handle')] === productType) add(card);
      });

      // 2) restliche Produkte desselben Typs. Der Versatz haengt an der Produkt-ID,
      //    damit nicht auf jeder Sweatshirt-Seite dieselben oben stehen.
      var rest = typeCards.filter(function (c) {
        return !seen[c.getAttribute('handle')];
      });
      if (rest.length > want) {
        var offset = parseInt(productId, 10) % rest.length;
        rest = rest.slice(offset).concat(rest.slice(0, offset));
      }
      rest.forEach(add);

      // 3) Notnagel fuer seltene Typen: die uebrigen Shopify-Empfehlungen
      if (picked.length < want) {
        recCards.forEach(add);
      }

      picked = picked
        .filter(function (c) {
          return c.getAttribute('handle') !== self.getAttribute('product-handle');
        })
        .slice(0, want);

      if (picked.length < 2) return this.giveUp(section);

      // Die Slider-Huelle (Pfeile + scroll-carousel) kommt fertig aus dem <template>
      // der Section. Karten ZUERST einsetzen, dann alles zusammen in den DOM: Prestiges
      // scroll-carousel richtet seine Scroll-Listener nur ein, wenn beim Aufwerten schon
      // mehr als eine Karte drin ist — sonst bleiben die Pfeile tot.
      var template = this.querySelector('template');
      var shell = template ? template.content.cloneNode(true) : null;
      var list = shell ? shell.querySelector('scroll-carousel') : null;

      if (!list) {
        shell = list = document.createElement('product-list');
        list.className = 'product-list justify-center';
      }

      picked.forEach(function (c) {
        list.appendChild(document.importNode(c, true));
      });
      this.replaceChildren(shell);
    }

    giveUp(section) {
      if (section) section.remove();
    }
  };

  if (!window.customElements.get('ljv-similar-products')) {
    window.customElements.define('ljv-similar-products', LjvSimilarProducts);
  }
})();
